module.exports = __webpack_public_path__ + "media/icons/download_global-0218c88e.svg";